// Route guards control what the UI shows. They are NOT a security boundary — RLS and server
// functions enforce access for every request regardless of what the browser renders.
import { satisfies } from './permissions/permissions.js';
import { getState } from './state.js';

export const MFA_ENROLL_PATH = '/profile/security';

export function appGuard(route) {
  const state = getState();
  if (state.mfaEnrollmentRequired && route.path !== MFA_ENROLL_PATH) return MFA_ENROLL_PATH;
  if (!satisfies(state.permissions, route.permission)) return 'forbidden';
  return true;
}
